import { useState } from "react";
import { Head, router } from "@inertiajs/react";

import Layout from "/AdminLayout";
import Modal from "/components/Modal";
import Switch from "/components/Switch";
import Button from "/components/Button";

export default function AdminUsersIndex({
  admin_users,
}) {
  const initialAdminUsers = admin_users.reduce(
    (result, currentItem) => (result[currentItem.id] = currentItem) && result,
    {}
  );
  const [managedAdminUsers, setManagedAdminUsers] = useState(initialAdminUsers);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [adminUserToDelete, setAdminUserToDelete] = useState();

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setProjectToDelete(null);
  };

  const handleDeleteClick = (adminUser) => {
    setAdminUserToDelete(adminUser);
    setIsDeleteModalOpen(true);
  };

  const deleteAdminUser = async () => {
    const adminUserId = adminUserToDelete.id;
    await router.delete(`/admin/admin_users/${adminUserId}`);
    setIsDeleteModalOpen(false);
  };

  const handlePartialChange = (id, updatedData) => {
    setManagedAdminUsers({ ...managedAdminUsers, [id]: { ...managedAdminUsers[id], ...updatedData } });
  };

  return (
    <>
      <Head>
        <title>Пользователи</title>
      </Head>

      <Modal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        className="modal--autowidth"
      >
        <div className="modal__text">
          Вы уверены, что хотите<br />удалить этого пользователя?
        </div>

        <div className="modal__actions">
          <Button onClick={deleteAdminUser} className="btn btn--dark">Удалить</Button>
          <Button onClick={handleCloseDeleteModal}>Отменить</Button>
        </div>
      </Modal>

      <div className="table-header">
        <div className="table-header__left">
          <h2>Пользователи</h2>
        </div>
        <div className="table-header__right">
          <a href="/admin/admin_users/new" className="btn">Добавить</a>
        </div>
      </div>

      <table className="tbl">
        <thead>
          <tr>
            <th>Имя Фамилия</th>
            <th>Почта</th>
            <th>Вкл</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(managedAdminUsers).map((id) => {
            const admin_user = managedAdminUsers[id];

            return (
              <tr key={admin_user.id}>
                <td>{admin_user.name_ru}</td>
                <td>{admin_user.email}</td>
                <td>
                  <Switch
                    value={admin_user.enabled}
                    name="enabled"
                    url={`/admin/admin_users/${admin_user.id}`}
                    onChange={(data) => handlePartialChange(admin_user.id, data)}
                  />
                </td>
                <td className="tbl-extra">
                  <div className="tbl-actions tbl-actions--hiding">
                    <div className="flex-row gap-3">
                      <a href={`/admin/admin_users/${admin_user.id}/edit`} className="lnk lnk--blue">Редактировать</a>
                      <Button className="lnk lnk--red" onClick={() => handleDeleteClick(admin_user)}>Удалить</Button>
                    </div>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}

// The layout is what carries the ToastProvider the switch reports through.
AdminUsersIndex.layout = (page) => <Layout children={page} />;
